import { render, staticRenderFns } from "./AppsToCheck.vue?vue&type=template&id=196ce425&scoped=true"
import script from "./AppsToCheck.vue?vue&type=script&lang=js"
export * from "./AppsToCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ce425",
  null
  
)

export default component.exports